export default __webpack_public_path__ + "static/media/slider1-left.2f3cd59b.svg";